import { usePageView } from '../../hooks/usePageView';

/**
 * 페이지 조회수 자동 추적 컴포넌트
 * BrowserRouter 내부에서 사용해야 합니다.
 */
export function PageViewTracker() {
  usePageView();
  return null;
}

export default PageViewTracker;
